import { snakeStore, DATA, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { RecipientService } from '@db/services/RecipientService';
import { isID } from '@shared/helpers/uid';
import { debug } from '@shared/helpers/debug';

export const recipients = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: ({ rootState }, params) => {
        const id = rootState.db.databases.show.current_database_id;
        if (isID(id)) {
          return RecipientService.getList(id, params);
        } else {
          debug.warn(id, 'id is not defined');
          return [];
        }
      },
      updateItemById: ({ getters, commit }, value) => {
        commit(
          DATA,
          [...getters[DATA]].map(i => {
            return i.id === value.id ? { ...i, ...value } : i;
          })
        );
      }
    },
    getters: {
      recipients: state => state.data.length
    }
  },
  true
);
